let fontLoadVersion = 0
let isListening = false
const listeners = new Set<() => void>()

function handleFontsLoaded() {
  fontLoadVersion += 1
  listeners.forEach(listener => listener())
}

function listenForFonts() {
  if (isListening || typeof document === "undefined" || !document.fonts) return
  document.fonts.addEventListener("loadingdone", handleFontsLoaded)
  isListening = true
}

export function getFontLoadVersion(): number {
  listenForFonts()
  return fontLoadVersion
}

export function subscribeToFontLoading(listener: () => void): () => void {
  listenForFonts()
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
